import type { UseFormRegisterReturn } from 'react-hook-form';

// "Each / Set / Kit" after a part or product price. Blank means not stated,
// and the site prints nothing after the price — what every older row shows.
export function PriceUnitSelect({ register }: { register: UseFormRegisterReturn }) {
  return (
    <select {...register} title="Shown after the price on the site, e.g. “$635.95 / set”">
      <option value="">— not stated</option>
      <option value="each">Each</option>
      <option value="set">Set</option>
      <option value="kit">Kit</option>
    </select>
  );
}
